import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementStatisticsIndexScene from 'scenes/management/statistics'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_STATISTICS_INDEX]: {
		component: ManagementStatisticsIndexScene,
	},
}

const ManagementStatisticsNavigator = ( props ) => {
	return (
		<Stack.Navigator
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementStatisticsNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementStatisticsNavigator
